// lcdcash-frontend/src/pages/account/MyAccountLayout.jsx
import * as React from 'react';
import { Container, Box } from '@mui/material';
import Navbar from './../components/Navbar';
import Footer from './../components/Footer';
import AccountNavbar from './../components/account/Navbar';
import { Outlet } from 'react-router-dom';

export default function MyAccountPage() {
  return (
    <>
      <Navbar />
      <Box sx={{ bgcolor: '#f7faf8', minHeight: '100vh', py: 1 }}>
        <Container maxWidth="lg">
          <Box sx={{ mb: 3 }}>
            <AccountNavbar />
          </Box>
          <Outlet />
        </Container>
      </Box>
      <Footer />
    </>
  );
}